<template>
  <main>
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1>
          <img src="images/basic/icon/back.svg" onclick="history.back()" class="back" />
          약관 및 정책
        </h1>
        <a class="h1_div"> </a>
      </div>
      <div class="div_padding"></div>

      <div class="menus">
        <table id="ver">
          <tr @click="goToTermsDetail(terms.nttId)" v-for="terms in termsList" :key="terms.nttSj">
            <th>{{ terms.nttSj }}</th>
            <td><img src="images/basic/icon/arrow-right-thin.svg" alt="" /></td>
          </tr>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import { fetchTermsList } from "@/api/notice";
export default {
  data() {
    return {
      termsList: [],
    };
  },
  created() {
    fetchTermsList().then(({ data }) => {
      this.termsList = data.resultList;
    });
  },
  methods: {
    goToTermsDetail(nttId) {
      this.$router.push({
        path: "/termsDetail",
        query: {
          nttId,
        },
      });
    },
  },
};
</script>

<style scoped>
.menus {
  width: 100%;
  padding: 0 30px;
}
table {
  font-size: 0.813em;
  width: 100%;
}
table tr {
  position: relative;
  display: flex;
  align-items: center;
  height: 55px;
  overflow-x: hidden;
}
table tr::after {
  content: "";
  border-top: 1px solid var(--Gray-Dark);
  width: 300%;
  position: absolute;
  left: 0;
  bottom: 0;
  transform-origin: left bottom;
  transform: scale(0.34);
  opacity: 0.3;
}
table tr:first-child::before {
  content: "";
  border-bottom: 1px solid var(--Gray-Dark);
  width: 300%;
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: left top;
  transform: scale(0.34);
  opacity: 0.3;
}
table tr th {
  font-weight: normal;
  text-align: left;
}
table tr td {
  color: #9ea3ab;
  text-align: right;
  flex-grow: 1;
}
</style>
